import { render } from "./EnbProdutos.vue?vue&type=template&id=625ad202&scoped=true"
import script from "./EnbProdutos.vue?vue&type=script&lang=js"
export * from "./EnbProdutos.vue?vue&type=script&lang=js"

import "./EnbProdutos.vue?vue&type=style&index=0&id=625ad202&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-625ad202"]])

export default __exports__